export default "__VITE_ASSET__DQ2hYu_D__"